<template>
  <v-container fluid>
    <v-row justify="space-around" class="fill-height" align="center">
      <v-col cols="3">
        <v-autocomplete
          v-model="poiId"
          :items="selectitems"
          item-value="id"
          item-text="name"
          :search-input.sync="search"
          outlined
          dense
          small-chips
          autofocus
          label="Poi"
          clearable
          hide-selected
          @change="navigate"
        >
          <template v-slot:item="{ item }">
            <v-list-item-avatar
              color="indigo"
              class="headline font-weight-light white--text"
            >
              {{ item.name.charAt(0) }}
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title v-text="item.name" />
              <v-list-item-subtitle v-text="item.city" />
            </v-list-item-content>
          </template>
        </v-autocomplete>
        <v-text-field label="first row text" v-model="preview.row1" />
        <v-text-field label="second row text" v-model="preview.row2" />
        <v-text-field label="hashtag text" v-model="preview.row3" />
        <v-color-picker
          v-model="preview.color"
          dot-size="25"
          hide-mode-switch
          mode="rgba"
          show-swatches
          swatches-max-height="200"
        />
      </v-col>
      <v-col class="fill-height" lg="3" md="4" sm="6">
        <router-view :preview="preview" @initialized="fillSelect" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import debounce from 'lodash.debounce';

const lsKey = 'banner-constructor-settings';

export default {
  name: 'Index',

  data() {
    return {
      poiId: null,
      selectitems: [],
      search: '',

      preview: localStorage.getItem(lsKey)
        ? JSON.parse(localStorage.getItem(lsKey))
        : {
          row1: 'first row',
          row2: 'second row',
          row3: 'hashtag',
          color: 'FFED54BF',
          badgeTopPos: 60,
        },
    };
  },

  created() {
    this.saveSettings = debounce(() => {
      localStorage.setItem(lsKey, this.previewWatchTrigger);
    }, 1000);

    this.searchPoi = debounce((val) => {
      this.$requestHelpers
        .post(
          'api/admin/poi/filteredAndPaginated',
          {
            itemsPerPage: -1, filters: { name: val }, sortBy: ['id'], sortDesc: [false],
          },
        )
        .then(({ data }) => { this.selectitems = data.data.filter((p) => p.videos.length > 0); });
    }, 1000);
  },

  deactivated() {
    this.$destroy();
  },

  computed: {
    previewWatchTrigger() {
      return JSON.stringify(this.preview);
    },
  },

  methods: {
    fillSelect(poi) {
      if (!this.selectitems.length) {
        this.selectitems.push(poi);
        this.poiId = poi.id;
      }
    },

    navigate() {
      if (!this.poiId) {
        this.$router.push({ name: 'banner-constructor' });
      } else if (this.$route.params.poiId !== this.poiId.toString()) {
        this.$router.push({ name: 'banner-constructor-poi', params: { poiId: this.poiId.toString() } });
      }
    },
  },

  watch: {
    previewWatchTrigger() {
      this.saveSettings();
    },

    search(val) {
      if (!val || val.length < 2) return;
      this.searchPoi(val);
    },
  },
};
</script>
